export var MERGE_CAPABILITY = 'czna-authorities.records.merge.post';
var IN_REVIEW = ['PENDING_REVIEW', 'PENDING_NATIONAL_REVIEW'];
/** A record in review the caller may cancel with a replacement — the redirect form. */
export var canRedirectRecord = function (record) { var _a, _b; return IN_REVIEW.includes(record.reviewStatus) && ((_b = (_a = record.actions) === null || _a === void 0 ? void 0 : _a.includes('redirect')) !== null && _b !== void 0 ? _b : false); };
/**
 * An ACTIVE record the caller may merge into another. Not a tombstone (`redirectedFrom` marks a
 * merged one, CZNA-767), and not a record in review that offers redirect — there the same
 * action is the redirect.
 */
export var canMergeRecord = function (record, hasPerm) {
    var _a, _b;
    return !record.redirectedFrom
        && record.status === 'ACTIVE'
        && ((_b = (_a = record.actions) === null || _a === void 0 ? void 0 : _a.includes('merge')) !== null && _b !== void 0 ? _b : false)
        && hasPerm(MERGE_CAPABILITY)
        && !canRedirectRecord(record);
};
